module.exports = __webpack_public_path__ + "static/media/searpent_headline_white.e65e27e0.png";